import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class ChatService {
    private roomSource = new BehaviorSubject('');
    roomId = this.roomSource.asObservable();
    
    constructor(private http: HttpClient) { }

    changeRoom(roomId:string) {
        this.roomSource.next(roomId)        
    }

    getRoom(perPage:number, page:number) {
        return this.http.get<any>(`${environment.apiUrl}/chat/room?perPage=${perPage}&page=${page}`)
    }
    getRoomId(roomId:string) {
        return this.http.get<any>(`${environment.apiUrl}/chat/room/${roomId}`)
    }
    getConversation(perPage:number, page:number, room:string) {
        return this.http.get<any>(`${environment.apiUrl}/chat/message?perPage=${perPage}&page=${page}&room=${room}`)
    }
    postMessage(value:any){
        return this.http.post<any>(`${environment.apiUrl}/chat/message`, value)        
    }

}